import { render, staticRenderFns } from "./AutoChargesTradeReport.vue?vue&type=template&id=61612164"
import script from "./AutoChargesTradeReport.vue?vue&type=script&lang=js"
export * from "./AutoChargesTradeReport.vue?vue&type=script&lang=js"
import style0 from "./AutoChargesTradeReport.vue?vue&type=style&index=0&id=61612164&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports